const comments = [
  {
    avatar: '吃',
    name: '吃瓜第一线',
    time: '3小时前',
    text: '今天这个瓜也太猛了，全程高能！完全没想到事情会这样反转，51每日大赛的更新速度真的没得说，每次都是第一时间吃到最新鲜的瓜。',
    likes: 2847,
  },
  {
    avatar: '瓜',
    name: '瓜田守望者',
    time: '5小时前',
    text: '每天必刷51每日大赛，比刷微博还勤快哈哈。这里的爆料整理得太清晰了，时间线一目了然，再也不用在各大平台来回切换找瓜吃了。',
    likes: 1923,
  },
  {
    avatar: '八',
    name: '八卦雷达',
    time: '2小时前',
    text: '这个爆料太及时了！刚在别的平台看到一点点风声，来这边就已经有完整的深度整理了。信源标注也很清楚，吃瓜吃得明明白白。',
    likes: 3156,
  },
  {
    avatar: '爆',
    name: '资深吃瓜人',
    time: '7小时前',
    text: '建议官方开个吃瓜交流群，大家一起讨论更有意思。最近娱乐圈的瓜一个接一个，信息太密集了，还好有51每日大赛帮忙梳理。',
    likes: 1089,
  },
  {
    avatar: '真',
    name: '理性吃瓜群众',
    time: '1小时前',
    text: '真实度很高，比某些平台的营销号靠谱多了。每条爆料都有来源标注，而且更新频率稳定，已经安利给身边所有爱八卦的朋友了。',
    likes: 4532,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">吃瓜群众热议</h2>
          <p className="text-sm text-foreground-500">来看看大家最近都在讨论什么瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 flex gap-4 transition-colors duration-200 hover:bg-background-200/70">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <span className="text-primary-700 font-bold text-sm">{c.avatar}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.text}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {c.likes.toLocaleString()}
                  </span>
                  <button className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">回复</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}